<template>
  <div class="app">
    <AppHeader/>
    <div class="wrapper">
      <router-view></router-view>
    </div>
    <AppFooter/>
  </div>
</template>
<script>
import AppHeader from '../components/HomeHeader'
import AppFooter from '../components/HomeFooter'
import api from '../api/rest'

export default {
  name: 'full',
  components: {
    AppHeader,
    AppFooter
  },
  computed: {}
}
</script>



// WEBPACK FOOTER //
// Frame.vue?5347711e